import request from 'superagent'

import config from '../Config'

export function getContactCenterStatus(brand = 'ARGOS') {
  const endpoint = config.getCmcStatusUrl()
  const url = `${endpoint}/?brand=${brand}&department=SERVICE`

  return request
    .get(url)
    .withCredentials()
    .then((result) => result.body)
}

export default {
  getContactCenterStatus,
}
